var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5236 50.2099H4.47659C3.62752 50.2099 2.81322 49.8726 2.21283 49.2722C1.61244 48.6718 1.27515 47.8575 1.27515 47.0084V9.70653L9.25137 1.79053H33.5236C34.3727 1.79053 35.187 2.12782 35.7874 2.72821C36.3877 3.3286 36.725 4.1429 36.725 4.99197V47.0084C36.725 47.8575 36.3877 48.6718 35.7874 49.2722C35.187 49.8726 34.3727 50.2099 33.5236 50.2099Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25137 1.79053V6.83162C9.25137 7.23471 9.17197 7.63384 9.01772 8.00625C8.86346 8.37865 8.63737 8.71702 8.35235 9.00204C8.06732 9.28707 7.72895 9.51316 7.35655 9.66741C6.98415 9.82167 6.58501 9.90106 6.18193 9.90106H1.27515",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64648 38.4985H31.3533",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93848 44.0107H19.6486",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2974 23.0213C27.1959 24.8143 26.5779 26.5396 25.5177 27.9892C24.4576 29.4388 23.0008 30.5506 21.3228 31.1907C19.6449 31.8308 17.8177 31.9717 16.0615 31.5965C14.3052 31.2213 12.6951 30.346 11.4252 29.0761C10.1554 27.8063 9.28007 26.1961 8.90486 24.4399C8.52965 22.6837 8.67058 20.8564 9.31065 19.1785C9.95073 17.5006 11.0626 16.0437 12.5122 14.9836C13.9617 13.9235 15.6871 13.3054 17.48 13.204C17.5485 13.2014 17.6168 13.2128 17.6807 13.2374C17.7447 13.262 17.803 13.2993 17.8521 13.3471C17.9012 13.3948 17.9402 13.452 17.9666 13.5152C17.9931 13.5785 18.0064 13.6464 18.0059 13.7149V21.7503C18.0059 21.948 18.0844 22.1375 18.2241 22.2772C18.3639 22.417 18.5534 22.4955 18.751 22.4955H26.7865C26.855 22.495 26.9229 22.5083 26.9861 22.5347C27.0493 22.5612 27.1065 22.6001 27.1543 22.6493C27.202 22.6984 27.2393 22.7567 27.2639 22.8207C27.2885 22.8846 27.2999 22.9529 27.2974 23.0213Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2981 19.7429C29.1223 17.5366 28.1662 15.4652 26.6012 13.9002C25.0362 12.3352 22.9648 11.3791 20.7585 11.2033C20.6647 11.1958 20.5703 11.2078 20.4813 11.2385C20.3923 11.2692 20.3106 11.318 20.2414 11.3817C20.1721 11.4455 20.1167 11.5228 20.0788 11.609C20.0408 11.6951 20.0211 11.7882 20.0208 11.8823V19.8026C20.0208 19.9824 20.0922 20.1549 20.2194 20.2821C20.3465 20.4092 20.519 20.4807 20.6988 20.4807H28.6191C28.7132 20.4804 28.8063 20.4606 28.8924 20.4227C28.9786 20.3847 29.0559 20.3293 29.1197 20.2601C29.1835 20.1908 29.2322 20.1091 29.2629 20.0201C29.2936 19.9311 29.3056 19.8367 29.2981 19.7429Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons03);
export default __webpack_public_path__ + "static/media/icons-03.54ce4e88f2f23b70d9a4db457ee3ec59.svg";
export { ForwardRef as ReactComponent };